export const config = {
  wp: 'https://cms.ezbizfile.com/wp-json/wp/v2/pages',
  apiVer1:
    'https://orders-uat.objectlegal.com:443/api/v1/public/fees?feeable_id=4&feeable_type=state&client_id=XXX&product_id[0]=2&product_id[1]=41&company_type=Corporation',
};
